// Copyright (c) 2017 Deere & Company

import PipCode, {getDefaultState as getPipCodeDefaultState} from '@deere/cps-it.warranty-model-factory/lib/pip-code';
import React, {PropTypes} from 'react';
import {
    filterCollection,
    sortCollection
} from '../../../../shared/services/collections';
import Accordion from '../../../../shared/components/accordion';
import {FormattedMessage} from 'react-intl';
import PipCodeRequestFilterOptions from '../../services/pip-code-request-filter-options';
import PipCodeRequestModal from './pip-code-request-modal';
import PipCodeRequestSortOptions from '../../services/pip-code-request-sort-options';
import PipCodeRequestsListItem from './pip-code-requests-list-item';
import RefinableListWidgetWithExport from '../../../../shared/components/refinable-list-widget/refinable-list-widget-with-export';
import SearchFilters from '../../../../shared/state/search-filters';
import TcsmApproveDenyModal from '../../state/tcsm-approve-deny-modal';
import {buildNumber} from '../../../../shared/services/build-number';

function handleExportToExcel() {

    this.actions.exportPipCodeRequests();

}

function handleFilterByChange(filterBy) {

    this.actions.updatePipCodeRequestListFilterBy(filterBy);

}

function handleSortByChange(sortBy) {

    this.actions.updatePipCodeRequestListSortBy(sortBy);

}

function handleSortDirectionChange(sortDirection) {

    this.actions.updatePipCodeRequestListSortDirection(sortDirection);

}

function handleOpenPipCodeRequestModal(item, actionToTake) {

    this.actions.pipCodeRequestItemToUpdate(item);
    this.actions.openPipCodeRequestModal(actionToTake);

}

function handleClosePipCodeRequestModal() {

    this.actions.closePipCodeRequestModal();
    this.actions.pipCodeRequestItemToUpdate(getPipCodeDefaultState());

}

function handlePipCodeRequestModalConfirmation(actionToTake, itemToUpdate) {

    this.actions.approveDenyPipCodeRequest(actionToTake, itemToUpdate);

}

function handlePipCodeTcsmCommentsChange(comments) {

    this.actions.updatePipCodeRequestTcsmComments(comments);

}

const PipCodeRequestsAccordion = props => {

    let sortedCollection;

    sortedCollection = [...props.pipCodeRequests];
    sortedCollection = sortCollection(props.pipCodeRequestSearchFilters.sortBy, props.pipCodeRequestSearchFilters.sortDirection, sortedCollection);
    sortedCollection = filterCollection(props.pipCodeRequestSearchFilters.filterBy, PipCodeRequestFilterOptions, sortedCollection);

    const body = (
        <div>
            <RefinableListWidgetWithExport
                hasResults={props.pipCodeRequests.length > 0}
                onExport={handleExportToExcel.bind(props)}
                onFilterByChange={props::handleFilterByChange}
                onSortByChange={props::handleSortByChange}
                onSortDirectionChange={props::handleSortDirectionChange}
                searchFilters={props.pipCodeRequestSearchFilters}
                sortOptions={PipCodeRequestSortOptions}
            />
            {sortedCollection.map(item =>
                <PipCodeRequestsListItem
                    item={item}
                    key={item.transactionId}
                    openPipCodeRequestModal={props::handleOpenPipCodeRequestModal}
                />
            )}
        </div>
    );

    const title = (
        <div className='pip-code-requests-title'>
            <FormattedMessage
                id='PIP_CODE_REQUESTS_WITH_COUNT'
                values={{
                    count: buildNumber(sortedCollection.length)
                }}
            />
        </div>
    );

    return props.pipCodeRequests.length > 0 &&
        <div>
            <Accordion
                accordionId='pip-code-requests'
                body={body}
                title={title}
            />
            <PipCodeRequestModal
                closePipCodeRequestModal={props::handleClosePipCodeRequestModal}
                onConfirmation={props::handlePipCodeRequestModalConfirmation}
                onPipCodeTcsmCommentsChange={props::handlePipCodeTcsmCommentsChange}
                pipCodeRequestItemToUpdate={props.pipCodeRequestItemToUpdate}
                pipCodeRequestModal={props.pipCodeRequestModal}
            />
        </div>;

};

PipCodeRequestsAccordion.displayName = 'PipCodeRequestsAccordion';
PipCodeRequestsAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    pipCodeRequestItemToUpdate: PropTypes.instanceOf(PipCode).isRequired,
    pipCodeRequestModal: PropTypes.instanceOf(TcsmApproveDenyModal).isRequired,
    pipCodeRequestSearchFilters: PropTypes.instanceOf(SearchFilters).isRequired,
    pipCodeRequests: PropTypes.arrayOf(PropTypes.instanceOf(PipCode)).isRequired
};

export default PipCodeRequestsAccordion;



// WEBPACK FOOTER //
// ./src/tcsm/wip/components/pip-code-requests/pip-code-requests-accordion.js